import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60aecdeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-record" }
const _hoisted_2 = { class: "search-form" }
const _hoisted_3 = { class: "table-container" }

import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import tablist from './tablist.vue'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import { ElLoading } from 'element-plus'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

dayjs.locale('zh-cn')

// 查询表单数据
const searchForm = ref({
  dateRange: [] // [开始日期, 结束日期]
})

// 表格数据和加载状态
const tableData = ref<any[]>([])
let loadingInstance: ILoadingInstance = {} as ILoadingInstance

const pickDay = ref<Date | null>(null)

const handleFocus = () => {
  pickDay.value = null
}

// 禁用未来日期（只允许选当前选择的开始日期前后10天的日期）
const disabledDate = (time: Date) => {
  if (pickDay.value) {
    const startTime = dayjs(pickDay.value.getTime()).subtract(9, 'day').valueOf()
    const endTime = dayjs(pickDay.value.getTime()).add(9, 'day').valueOf()
    return (
      time.getTime() < startTime ||
      time.getTime() > endTime ||
      time.getTime() > Date.now()
    )
  } else {
    return time.getTime() > Date.now()
  }
}

const handleChange = (val: Date[]) => {
  const [pointDay] = val
  pickDay.value = pointDay
}

/**
 * 生成表格数据
 */
const generateTableData = async (dateRange?: any) => {
  if (document.querySelector('.table-container')) {
    if (loadingInstance && typeof loadingInstance.close === 'function') {
      loadingInstance.close()
    }
    loadingInstance = ElLoading.service({
      target: '.table-container',
      text: '加载中....',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.8)',
      fullscreen: false
    })
  }

  try {
    let allData = [] as any
    if (dateRange && dateRange.length === 2) {
      const startDate = dayjs(dateRange[0])
      const endDate = dayjs(dateRange[1])

      if (startDate.isAfter(endDate)) {
        ElMessage.error('开始日期不能晚于结束日期')
        tableData.value = []
        return
      }

      const totalDays = endDate.diff(startDate, 'day') + 1

      for (let i = 0; i < totalDays; i++) {
        const currentDate = endDate.subtract(i, 'day')
        const dateStr = currentDate.format('YYYY-MM-DD')
        const dateCN = currentDate.format('YYYY年MM月DD日')

        allData.push({
          date: dateStr,
          name: `${dateCN}通知提醒阅读情况`
        })
      }
    } else {
      // 默认生成最近10天
      for (let i = 0; i < 10; i++) {
        const currentDate = dayjs().subtract(i, 'day')
        const dateStr = currentDate.format('YYYY-MM-DD')
        const dateCN = currentDate.format('YYYY年MM月DD日')

        allData.push({
          date: dateStr,
          name: `${dateCN}通知提醒阅读情况`
        })
      }
    }

    tableData.value = allData
  } catch (error) {
    ElMessage.error('数据加载失败，请重试')
    tableData.value = []
  } finally {
    if (loadingInstance && typeof loadingInstance.close === 'function') {
      loadingInstance.close()
    }
  }
}

// 查询按钮点击事件
const onSearch = () => {
  generateTableData(searchForm.value.dateRange)
}

// 重置查询条件
const resetSearch = () => {
  searchForm.value.dateRange = []
  generateTableData([])
}

const tablistRef = ref<any>()

// 查看按钮点击事件
const handleView = (row: any) => {
  tablistRef.value.open(row)
}

// 页面初始化
onMounted(() => {
  generateTableData([])
})

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        inline: true,
        model: searchForm.value,
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "时间范围：" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: searchForm.value.dateRange,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.value.dateRange) = $event)),
                type: "daterange",
                "range-separator": "-",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD",
                "disabled-date": disabledDate,
                onCalendarChange: handleChange,
                onFocus: handleFocus
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: onSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查询")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: resetSearch }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_table, {
        data: tableData.value,
        border: "",
        style: {"width":"100%"},
        height: "700"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "date",
            label: "日期",
            width: "130"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "标题"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (handleView(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查看")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(tablist, {
      ref_key: "tablistRef",
      ref: tablistRef
    }, null, 512)
  ]))
}
}

})